import { useQuery } from "@tanstack/react-query";
import { api } from "../../../../singleton/axios";

export interface ExchangeMarketHours {
  exchange: string;
  name: string;
  openingHour: string;
  closingHour: string;
  timezone: string;
  isMarketOpen: boolean;
}

export function useExchangeMarketHours(exchange: string | undefined) {
  return useQuery<ExchangeMarketHours, Error>({
    queryKey: ["exchangeMarketHours", exchange],
    queryFn: async () => {
      const { data } = await api.get<ExchangeMarketHours>("/exchange-market-hours", {
        params: { exchange },
      });
      return data;
    },
    enabled: !!exchange,
    // Market state flips twice a day — a minute of staleness is invisible,
    // and the old 15s/stale-0 pair re-rendered every subscribed chart 4×/min.
    refetchInterval: 60 * 1000,
    staleTime: 60 * 1000,
    gcTime: 5 * 60 * 1000,
  });
}
